'use client';

import { LegalPageLayout } from '../components/legal-page-layout';

export const PrivacyPolicyPage = () => {
	return <LegalPageLayout documentType="privacy-policy" />;
};
